import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'
import { EventsOverview } from '@/events/components/EventsOverview'
import {
  defaultEventsSearch,
  eventsSearchParamsSchema,
} from '@/events/utils/eventsSearchParams'

export const Route = createFileRoute('/company/_management/events/overview')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-events',
        }),
      },
    ],
  }),
  validateSearch: eventsSearchParamsSchema,
  search: {
    middlewares: [stripSearchParams(defaultEventsSearch)],
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <EventsOverview />
}
